export default from './BuyerMessages';



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/index.js